import React, { useState } from "react";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

export function useSort(defaultKey = "", defaultDir = "asc") {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [sortDir, setSortDir] = useState(defaultDir);
  const onSort = (key) => {
    if (key === sortKey) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else { setSortKey(key); setSortDir("asc"); }
  };
  const setSort = (key, dir = "asc") => { setSortKey(key); setSortDir(dir); };
  return { sortKey, sortDir, onSort, setSort };
}

export function sortRows(rows, sortKey, sortDir, accessors = {}) {
  if (!sortKey) return rows;
  const get = accessors[sortKey] || ((r) => r[sortKey]);
  const sorted = [...rows].sort((a, b) => {
    const av = get(a), bv = get(b);
    if (typeof av === "number" && typeof bv === "number") return av - bv;
    return String(av ?? "").localeCompare(String(bv ?? ""), undefined, { numeric: true, sensitivity: "base" });
  });
  return sortDir === "desc" ? sorted.reverse() : sorted;
}

export function SortableTh({ label, sortKey, activeKey, dir, onSort, className = "", testid }) {
  const active = activeKey === sortKey;
  const Icon = !active ? ArrowUpDown : dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <th className={className}>
      <button
        type="button"
        data-testid={testid}
        onClick={() => onSort(sortKey)}
        className="inline-flex items-center gap-1 uppercase tracking-wider text-xs font-semibold transition-opacity hover:opacity-70"
        style={{ color: active ? "var(--sj-primary)" : "inherit" }}
      >
        {label}
        <Icon className="h-3 w-3" style={{ opacity: active ? 1 : 0.4 }} />
      </button>
    </th>
  );
}
